module.exports = __webpack_public_path__ + "media/images/ecalls/icon_checked_circle_grey-49b1ae46c90ba4b9d0045e03758c45b3.png";